import React, { useEffect, useState } from 'react'
import "../../assets/sass/shareStyle.scss";
import "../../assets/sass/orderStyle.scss";
import "../../assets/sass/paymentStyle.scss";
import { FaArrowLeft } from "react-icons/fa";
import TabTitleChanger from "../TabTitleChanger";
import usePageNavigation from '../../uesPageNavigation';
import { IoIosArrowForward } from 'react-icons/io';
import { PaymentMethods } from '../../constants/paymentMethods';

export default function PaymentMethod() {

    const { navigateToPage, state } = usePageNavigation(); // Custom hook to navigate


    const [isOnTop, setIsOnTop] = useState(false);
    const [isAlert, setIsAlert] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [alertValue, setAlertValue] = useState("");
    const [paymentCount, setPaymentCount] = useState(0);

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

    useEffect(() => {
        setPaymentCount(state.paymentCount);
        window.scrollTo({
            top: 0, // Scroll to the top
            behavior: "smooth", // Smooth scrolling transition
        });
        // Check when the component mounts
        checkIfAtTop();

        // Optionally, you can listen to scroll events and check in real-time
        window.addEventListener("scroll", checkIfAtTop);

        // Cleanup listener on component unmount
        return () => window.removeEventListener("scroll", checkIfAtTop);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const checkIfAtTop = () => {
        if (window.scrollY === 0 || document.documentElement.scrollTop === 0) {
            setIsOnTop(true);
        } else {
            setIsOnTop(false);
        }
    };

    const handleRevertServicePrice = (grandTotal) => {
        const movingFee = state.userInfo.movingFee;

        const servicePrice =
            (grandTotal - 1.146 * movingFee) /
            1.146 /
            (1 - state.discountInfo.discountResult / 100);

        // Round and return the final value
        return Math.round(servicePrice);
    };

    const handleNavigateBack = () => {
        navigateToPage("/summaryOrder", {
            moveFrom: state.moveFrom,
            orderType: state.orderType,
            paymentCount: handleRevertServicePrice(paymentCount),
            discountInfo: state.discountInfo,
            workingTime: state.workingTime,
            userInfo: {
                firstName: state.userInfo.firstName,
                lastName: state.userInfo.lastName,
                phone: state.userInfo.phone,
                email: state.userInfo.email,
                prefecture: state.userInfo.prefecture,
                district: state.userInfo.district,
                town: state.userInfo.town,
                postCode: state.userInfo.postCode,
                addDetail: state.userInfo.addDetail,
                movingFee: state.userInfo.movingFee,
            },
        });
    };
    const formatNumber = (number) => {
        return number.toLocaleString();
    };
    const getServiceType = (type) => {
        switch (type) {
            case 0:
                return "Hourly Service";
            case 1:
                return "Daily Service";
            case 2:
                return "Custom Service";
            default:
                return "";
        }
    };

    const handleNavigate = () => {
        navigateToPage("/paymentInformation")
    }


    return (
        <>
            <TabTitleChanger title="Payment Methods" />
            <main className="content">
                <div className="payment__container">
                    <div className={`page__headline ${isOnTop && `onTop`}`}>
                        <div
                            className="page__headline_icon_container"
                            onClick={handleNavigateBack}
                        >
                            <FaArrowLeft className="page__headline_icon" />
                        </div>
                        <div className="page__headline_title">Payment Methods</div>
                    </div>
                    <div className="payment__content">
                        <div className="payment__info">
                            <div className="payment__info_content">
                                <div className="payment__info_item">
                                    <div className="payment__info_item_title">Service:</div>
                                    <div className="payment__info_item_value">
                                        {getServiceType(state.orderType)}
                                    </div>
                                </div>
                                <div className="payment__info_item">
                                    <div className="payment__info_item_title highlight">
                                        Total:
                                    </div>
                                    <div className="payment__info_item_value highlight">
                                        {formatNumber(Math.round(paymentCount))}¥
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='payment__methods'>
                            {PaymentMethods.map((method) => (
                                <div key={method.id}

                                    className={`payment__method_item ${selectedPaymentMethod === method.id ? 'selected' : ''}`} onClick={() => setSelectedPaymentMethod(method.id)}>
                                    <img src={method.logo} alt="Wise Payment" className='payment__method_icon' />
                                    <div className='payment__method_info'>
                                        <div className={`payment__method_item_title ${selectedPaymentMethod === method.id ? "selected" : ""}`}>{method.name}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {selectedPaymentMethod && (<button
                            className="payment__button"
                            onClick={handleNavigate}
                        >
                            <div className="payment__button_value">
                                Proceed to Payment
                            </div>
                            <IoIosArrowForward className="payment__button_icon" />
                        </button>)}
                    </div>
                    {isAlert && (
                        <div className="pop__container">
                            <div className="pop__content">
                                <div className="pop__alert">{alertValue}</div>
                                <div className="pop__close" onClick={() => setIsAlert(false)}>
                                    close
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main></>
    )
}
